export enum EpcEnergyEfficiencyRating {
    A = 'A',
    APlus = 'A+',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
    F = 'F',
    G = 'G',
    H = 'H',
    DiagnosisNotRequired = 'DiagnosisNotRequired',
    IDontKnow = 'IDontKnow',
    NoEnergyDiagnosis = 'NoEnergyDiagnosis',
}

export const germanEpcEnergyEfficiencyRatings: EpcEnergyEfficiencyRating[] = [
    EpcEnergyEfficiencyRating.APlus,
    EpcEnergyEfficiencyRating.A,
    EpcEnergyEfficiencyRating.B,
    EpcEnergyEfficiencyRating.C,
    EpcEnergyEfficiencyRating.D,
    EpcEnergyEfficiencyRating.E,
    EpcEnergyEfficiencyRating.F,
    EpcEnergyEfficiencyRating.G,
    EpcEnergyEfficiencyRating.H,
    EpcEnergyEfficiencyRating.DiagnosisNotRequired,
    EpcEnergyEfficiencyRating.IDontKnow,
    EpcEnergyEfficiencyRating.NoEnergyDiagnosis,
];

export const belgianEpcEnergyEfficiencyRatings: EpcEnergyEfficiencyRating[] = [
    EpcEnergyEfficiencyRating.A,
    EpcEnergyEfficiencyRating.B,
    EpcEnergyEfficiencyRating.C,
    EpcEnergyEfficiencyRating.D,
    EpcEnergyEfficiencyRating.E,
    EpcEnergyEfficiencyRating.F,
    EpcEnergyEfficiencyRating.G,
    EpcEnergyEfficiencyRating.DiagnosisNotRequired,
    EpcEnergyEfficiencyRating.IDontKnow,
    EpcEnergyEfficiencyRating.NoEnergyDiagnosis,
];

export const frenchEpcEnergyEfficiencyRatings: EpcEnergyEfficiencyRating[] = [
    EpcEnergyEfficiencyRating.A,
    EpcEnergyEfficiencyRating.B,
    EpcEnergyEfficiencyRating.C,
    EpcEnergyEfficiencyRating.D,
    EpcEnergyEfficiencyRating.E,
    EpcEnergyEfficiencyRating.F,
    EpcEnergyEfficiencyRating.G,
    EpcEnergyEfficiencyRating.DiagnosisNotRequired,
    EpcEnergyEfficiencyRating.IDontKnow,
    EpcEnergyEfficiencyRating.NoEnergyDiagnosis,
];
